import Vue from 'vue';

Vue.filter('filterString',str=>{
	// console.log(str.replace(/\r|\n/ig,""),'--------===========')
	return str.replace(/\r|\n/ig,"")
})

// 格式化数字
Vue.filter('formatNumberTwo', (number, tag = 'k') => {
  number = Number(number);
  if (number >= 1000) {
      return (Math.floor(number / 100) / 10).toFixed(1) + tag;
  } else {
    return number;
  }
});



// WEBPACK FOOTER //
// ./src/utils/filter.js